import { CHART_ELEMENT_ID, SpecificChartFunctionality } from 'finviz-charts/app/constants/common'
import { ChartLayoutWithGlobalState } from 'finviz-charts/app/lib-export'

import { getChartLayoutSizeConfig, useChartLayoutWidthWatch } from '../../quote/use-chart-layout-width-watch'
import { getInitChartConfig } from '../getInitChartConfig'

interface ResizableChartLayoutWithGlobalStateProps {
  specificChartFunctionality: SpecificChartFunctionality
}

export const ResizableChartLayoutWithGlobalState = ({
  specificChartFunctionality,
}: ResizableChartLayoutWithGlobalStateProps) => {
  useChartLayoutWidthWatch()
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const chartConfig = getInitChartConfig()

  if (!chartConfig.specificChartFunctionality) {
    chartConfig.specificChartFunctionality = specificChartFunctionality
  }

  return (
    chartEl && (
      <ChartLayoutWithGlobalState
        config={{
          ...chartConfig,
          ...getChartLayoutSizeConfig(chartConfig),
        }}
        parentElement={chartEl}
      />
    )
  )
}
